<template>
  <b-modal :id="id" :cancel-title="$t('_cancel')" ref="send_voucher" :title="$t(title)"
           :hide-footer="!toCustomRecipients" :ok-title="$t('_send')"
           @ok="sendToCustomRecipients" @close="reset" @cancel="reset" @hidden="reset"
  >
    <frontoffice-loader v-if="isLoading && !displayError" />

    <div v-else>
      <div id="selection" v-if="!toCustomRecipients">
        <p>{{ $t('_whatToDo') }}</p>

        <div class="buttons">
          <button class="btn orange-white" @click="sendToTravellers">
            {{ $t('_sendToTravellers') }}
          </button>

          <button class="btn orange-white" @click="toCustomRecipients = true">
            {{ $t('_enterAddresses') }}
          </button>
        </div>
      </div>

      <div id="action" v-if="toCustomRecipients" :style="{marginTop: '1em'}">
        <text-input :required="true" :name="id" type="email"
                    v-model="submitterInfos.values.email"
                    :label="$t(label)" :placeholder="$t(placeholder)"
        />
      </div>
    </div>

    <b-alert v-if="displayError" variant="danger" show class="col-12">
      {{ errorMessage }}
    </b-alert>
  </b-modal>
</template>

<script>
import textInput from "@/components/frontoffice/form/baseInput/text"
import modalMixin from '@/components/frontoffice/Booking/modal/mixin'
import frontofficeLoader from '@/components/frontoffice/loader'
import FormSubmitter from '@/api/formSubmitter'

export default {
  components: {
    textInput,
    frontofficeLoader
  },

  mixins: [modalMixin],

  props: {
    id: {
      type: String,
      default: 'send_voucher'
    }
  },

  data () {
    return {
      isLoading: false,
      submitterInfos: {
        values: {
          email: ''
        }
      },
      displayError: false,
      errorMessage: null,
      closeAfterServerResponse: true,
      title: 'booking.send_voucher.title',
      label: 'booking.send_voucher.label',
      placeholder: 'booking.send_voucher.placeholder',
      toCustomRecipients: false
    }
  },

  methods: {
    sendToCustomRecipients (event) {
      event.preventDefault()
      this.isLoading = true
      this.displayError = false

      if (!this.submitterInfos.values.email) {
        this.setErrorMessage('booking.send_voucher.no_email')
      } else {
        this.confirm('send_voucher')
      }
    },

    sendToTravellers () {
      this.isLoading = true
      this.displayError = false
      this.confirm('notify_travellers')
    },

    confirm (type) {
      let submitter = new FormSubmitter(type)
      submitter.submitRequest(this.submitterInfos.values, this.bookingId)
        .then(response => {
          if (response.data.success) {
            this.dealSuccess()
          } else {
            this.dealFailure(response.data.errors)
          }
        })
    },

    setErrorMessage (msg) {
      this.displayError = true
      this.isLoading = false
      this.errorMessage = this.$te(`error.${msg}`)
        ? this.$t(`error.${msg}`)
        : this.$te(msg)
        ? this.$t(msg)
        : this.$t('booking.send_voucher.error')
    },

    reset () {
      this.submitterInfos.values.email = ''
      this.isLoading = false
      this.displayError = false
      this.toCustomRecipients = false
    }
  },

  computed: {
    successMessage () {
      let email = this.submitterInfos.values.email

      if (email) {
        if (email.includes(';')) {
          email = email.replace(/;/gi, ',')
          email = email.replace(/\s+/gi, ' ')
          let i = email.lastIndexOf(',')
          let rep = this.$t('_and')
          email = email.substring(0, i) + rep + email.substring(i + 1)
        }

        return this.$t('booking.send_voucher.success', {email: email})
      }

      return this.$t('booking.notify_travellers.success')
    }
  },

  watch: {
    isLoading (val) {
      this.title = val ? '' : 'booking.send_voucher.title'
    }
  }
}
</script>

<style lang="scss">
  #selection {
    p {
      margin-bottom: 1em;
    }

    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-around
    }
  }
</style>
